export const environment = {
  app: 'CoviFactura',
  buyers: 'https://clientes.covifactura.com/compradores',
  cashNowMicrofrontUrl: 'https://clientes.covifactura.com/cajaya/#/caja-ya/my-bills',
  covifacturaLandingUrl: 'https://covifactura.com',
  electronicSignatureUrl: 'https://faudigital.covifactura.com/#/firma-de-documentos',
  uploadDocumentsUrl: 'https://clientes.covifactura.com/#/upload-file/',
  whatsAppUrl: 'https://api.whatsapp.com/send?phone=573102222377',
  urlApi: 'https://wsclifac.c0v.co/api/covifacturapi/servicios',
  urlApiBacking: 'https://asr.c0v.co/backingsPostgreSQL',
  urlApiCY: 'https://wscovpsdo.c0v.co/cajaya/api/v1',
  urlApiDev: 'https://wsclifac.c0v.co',
  urlApiImg: 'https://admindigital.c0v.co', 
  urlApiNit: 'https://wscovp.c0v.co',
  urlApiPayzen: 'https://ws.micovinoc.com:18443/PayzenCorporativo/servicios',
  urlApiPostgres: 'https://wscovp.c0v.co',
  urlApiReports: 'https://asr.c0v.co/reportcovifactura/api/v1',
  urlApiProd: 'https://wsclifac.c0v.co/api/covifacturapi/servicios',
  urlEndpoint:
    'https://wsconsultarpdfxmlfactura.dispafel.com:443/DFFacturaElectronicaConsultarPdfXmlFactura/consultarArchivos',
  backingsApiKey: 'CLIENT_APP-b4ck1ng5:53@#thvf53%8',
  buyerIntApiKey: 'CLIENT_APP-124mk12pcas1:zzqwe12WERRcas2',
  cashNowApiKey: 'CLIENT_APP-Cay3RAhy:i&h%ZYKU6z',
  commonsApiKey: 'CLIENT_APP-c0mm0n5:42#@hj78rt%3',
  coviresourceApiKey: 'CLIENT_APP-23KPP1P3039MAS312:RtVEu22126043108@FPEMV',
  expressReportApiKey: 'CLIENT_APP-exPr33xx:Fa12sd@htfl',
  newCoviFacturaApiKey: 'CLIENT_APP-doaneion45012:psnwods@3801VaPFRM',
  newLoginApiKey: 'CLIENT_APP-WL2PjEz9:4d3J9FLnYB2%',
  reportsApiKey: 'CLIENT_APP-exPr33xx:Fa12sd@htfl',
  postgres: true,
  production: true,
}; 